import React, { useState, useEffect } from "react";
import { Button } from "./Button.tsx";

const CookieNotice: React.FC = () => {
  const [showNotice, setShowNotice] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem("cookies-accepted");
    if (!accepted) {
      setShowNotice(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookies-accepted", "true");
    setShowNotice(false);
  };

  if (!showNotice) {
    return null;
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-gray-900 text-white p-4 shadow-lg z-50">
      <div className="container mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="text-sm">
          <p>
            We use cookies and Firebase Authentication to provide you with the
            best experience. By continuing to use this site, you agree to our
            use of these services.{" "}
            <a
              href="/privacy"
              className="underline hover:text-gray-300"
              target="_blank"
              rel="noopener noreferrer"
            >
              Learn more
            </a>
          </p>
        </div>
        <Button variant="primary" onClick={handleAccept} className="shrink-0">
          Accept
        </Button>
      </div>
    </div>
  );
};

export { CookieNotice };
